// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__nxlDe","customTheme":"Tooltip_customTheme__qYwX5","place-top":"Tooltip_place-top__kqnjV"};